export class GetGdsgRegionStatsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "windowStartMs",
            "baseName": "windowStartMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "windowEndMs",
            "baseName": "windowEndMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bucketIntervalMs",
            "baseName": "bucketIntervalMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<GdsgRegionStats>",
            "format": ""
        },
        {
            "name": "storageByBucket",
            "baseName": "storageByBucket",
            "type": "Array<GdsgStorageByBucketEntry>",
            "format": ""
        },
        {
            "name": "storageByTier",
            "baseName": "storageByTier",
            "type": "Array<GdsgStorageByTierEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetGdsgRegionStatsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
